import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Partner } from './partner';


@JsonObject('PartnerSearchResults')
export class PartnerSearchResults extends SearchResults {
    @JsonProperty('results', [Partner])
    results: Partner[] = [];
}
